module.exports = __webpack_public_path__ + "static/media/12660184_1061101663911255_1302552109_n.56b27ed2.jpg";